export default {
  ACTIVE: `Active`,
  INACTIVE: `Inactive`,
  DRAFT: `Draft`,
  CLOSED: `Closed`,
  ACTIVATION_IN_PROGRESS: 'Activation in Progress'
};
